import { useState } from "react";
import dynamic from "next/dynamic";
import parser from "react-html-parser";
import styles from "./InfoList.module.scss";
import { FaAngleUp } from "react-icons/fa";

const Viewer = dynamic(
  () => import("@toast-ui/react-editor").then((m) => m.Viewer),
  { ssr: false },
);

/**
 * @description FAQ 리스트 컴포넌트
 * @param data
 * @returns {JSX.Element}
 * @constructor
 */
const InfoList = ({ data }) => {
  const [isItemOpen, setItemOpen] = useState(false);

  return (
    <div className={styles.wrap} onClick={() => setItemOpen((prev) => !prev)}>
      <div className={styles.title}>
        <FaAngleUp
          style={{ transform: isItemOpen ? "rotate(180deg)" : "rotate(90deg)" }}
        />
        {parser(data.Q)}
        {/* {parser(data.Title)} */}
      </div>
      <div
        className={styles.container}
        style={{ height: isItemOpen ? "" : 0, padding: isItemOpen ? "" : 0 }}
      >
        {/*<Viewer initialValue={data.A} />*/}
        {parser(data.A)}
      </div>
    </div>
  );
};

export default InfoList;
